import Toggle from './Toggle.vue'

export default Toggle
